import ACTIONS from '../actions';

const dayList = (state = {}, action) => {
    switch (action.type) {
        case ACTIONS.CALENDAR_SETUP:
            return [...action.payload.result];
        case ACTIONS.DAYS_RELOAD:
            return {
                ...state,
                ...action.payload.result.days
            };
        case ACTIONS.DAYS_CLEAR:
            return {};
        case ACTIONS.CALENDAR_PROGRAM_UPDATE_LENGTH:
            const newState = [];
            const totalDays = action.weeksLength * 7;
            for (let i = 0; i < totalDays; i++) {
                const week = Math.floor(i / 7);
                const day = Math.abs(week * 7 - i);
                const key = `${week}_${day}`;
                newState.push(key);
            }
            return newState;
        default:
            return state;
    }
};

export default dayList;
